import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {
  ButtonContainer,
  ButtonItem,
  RadioItem,
  FormUnit,
  FormUnitRow,
  FormUnitCell,
} from "@/components/modules";
import { GeoMap } from "@/geoMap/GeoMap";
import { ref, withDefaults } from "vue";
import { CommonView } from "../common/CommonView";

/**
 * propsプロパティ定義
 */
interface Props {
  geoMap: GeoMap;
  commonView: CommonView;
  isOpen: boolean;
}
enum ExportFormatList {
  CSV = "CSV",
  GeoJSON = "GeoJSON",
}

/**
 * 出力フォーマット状態
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'export-bulk',
  props: {
    geoMap: {},
    commonView: {},
    isOpen: { type: Boolean }
  },
  emits: ["exportBulk"],
  setup(__props: any, { emit }) {

const props = __props;




/**
 * 出力フォーマット定義
 */
const exportFormat = ref(ExportFormatList.CSV);

/**
 * 出力押下
 */
const onExportClick = async (): Promise<void> => {
  emit("exportBulk", exportFormat.value);
};

/**
 * 選択市区町村更新処理
 */
const onExportFormatUpdate = (value: string) => {
  exportFormat.value = ExportFormatList[value as keyof typeof ExportFormatList];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(FormUnit), {
      column: ['36px', '160px', '50px'],
      "gap-row": "15px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitCell), { size: "m" }, {
          default: _withCtx(() => [
            _createTextVNode("属性出力対象は、現在表示している全ての属性画面の属性となります。")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(FormUnit), {
      modifires: "check-items-row",
      column: ['36px', '160px', '50px'],
      "gap-row": "15px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createTextVNode(" -出力形式を選択※ ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(FormUnit), {
      modifires: "check-items-row",
      column: ['36px', '160px', '50px'],
      "gap-row": "15px"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(FormUnitRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createVNode(_unref(RadioItem), {
                  label: "CSV",
                  name: "bulk-exportFormat",
                  value: ExportFormatList.CSV,
                  checked: exportFormat.value === ExportFormatList.CSV,
                  onUpdate: onExportFormatUpdate
                }, null, 8, ["value", "checked"])
              ]),
              _: 1
            }),
            _createVNode(_unref(FormUnitCell), null, {
              default: _withCtx(() => [
                _createVNode(_unref(RadioItem), {
                  label: "GeoJSON",
                  name: "bulk-exportFormat",
                  value: ExportFormatList.GeoJSON,
                  checked: exportFormat.value === ExportFormatList.GeoJSON,
                  onUpdate: onExportFormatUpdate
                }, null, 8, ["value", "checked"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(ButtonContainer), { align: "right" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ButtonItem), { onClick: onExportClick }, {
          default: _withCtx(() => [
            _createTextVNode("出力")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_1,
    _createTextVNode(" ※一括出力の対象データ"),
    _hoisted_2,
    _createTextVNode(" 交通量データ、一般交通量調査データ、OD、交通事故統計情報、ロードキル ")
  ], 64))
}
}

})